/*

// IE11 compatibility
var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
var pageReadyEvent = isIE11 ? 'ready' : 'swup:pageView';

jQuery( document ).on( pageReadyEvent, function () {
  jQuery( document ).trigger( 'page.ready' );
} );

jQuery( function ( $ ) {

  // We are using SWUP to take care of AJAX & History management 🙌
  // https://github.com/gmrchk/swup

  if ( isIE11 ) {
    return;
  }

  var swupOptions = {
    debugMode: true,
    containers: [ '#page-container' ],
    plugins: [
      //new SwupGaPlugin(),
      //new SwupPreloadPlugin()
    ]
  };

  if ( $( '#wpadminbar' ).length ) {
    // let's also switch out the WP Admin Bar if we're logged in
    swupOptions.containers.push( '#wpadminbar' );
  }

  window.theswup = new Swup( swupOptions );

} );

// Run any inline scripts (fixes Gravity Forms)
// ---
jQuery( document ).on( 'swup:contentReplaced', function () {
  $( 'main script' ).each( function () {
    eval( $( this ).html() );
  } )
} );

*/